import styled from 'styled-components';
import { Button } from '../../../../../../common/components/Button/Button';
import { Paragraph } from '../../../../../../common/components/Typography/Paragraph/Paragraph';
import { ThemeColours } from '../../../../../../common/styles/ThemeColours';
import {
  FontSize,
  FontWeight,
  FONT_STACK,
  LineHeight,
} from '../../../../../../common/styles/constants';
import { onMobile } from '../../../../../../common/styles/onMobile';
import { propSwitch } from '../../../../../../common/util/propSwitch';
import { DentalPriceBracket } from './getDentalPricing';

export const DentalPricingView = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  ${FONT_STACK}
`;

export const Label = styled.div`
  color: ${ThemeColours.black};
  flex-shrink: 0;
  font-size: 12px;
  font-weight: ${FontWeight.SEMI_BOLD};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 120px;
`;

export const Value = styled.div`
  align-items: center;
  color: ${ThemeColours.mono700};
  display: inline-block;
  font-size: 12px;
  min-width: 0;
`;

export const SubValue = styled.span`
  color: ${ThemeColours.mono600};
  margin-inline-start: 5px;
`;

export const Icon = styled.svg`
  color: ${ThemeColours.primary600};
  fill: currentColor;
  max-height: 24px;
  max-width: 24px;
`;

export const IconCircle = styled.div`
  align-items: center;
  background-color: ${ThemeColours.mono200};
  border-radius: 100%;
  display: flex;
  flex-shrink: 0;
  height: 20px;
  justify-content: center;
  margin-inline-end: 4px;
  width: 20px;
`;

export const HelpIconWrapper = styled.div`
  cursor: pointer;
  display: inline-block;
  margin-inline-start: 4px;
  padding-bottom: 0;
  position: relative;
  vertical-align: middle;

  ${onMobile} {
    padding-bottom: 0;
  }
`;

export const StyledOkButton = styled(Button)`
  margin-bottom: 8px;
  margin-top: 24px;
`;

export const StyledDollar = styled.span<{ isGreen: boolean }>`
  color: ${propSwitch('isGreen', ThemeColours.positive, ThemeColours.mono300)};
  font-size: 14px;
  letter-spacing: 1px;
`;

export const DetailedText = styled.span`
  margin-inline-start: 4px;
  vertical-align: top;
`;

export const View = styled.div`
  display: flex;
  flex-direction: row;
  ${FONT_STACK}
  gap: 10px;
`;

export const Description = styled(Paragraph)`
  color: ${ThemeColours.mono700};
  font-size: ${FontSize.EXTRA_SMALL};
  font-weight: ${FontWeight.REGULAR};
  line-height: ${LineHeight.EXTRA_SMALL};
  margin: 14px 0 0;
`;

export const PriceText = styled(Paragraph)<{ priceBracket: DentalPriceBracket }>`
  font-size: ${props => (props.priceBracket === 'med' ? FontSize.SMALL : FontSize.HEADING_5)};
  font-weight: ${FontWeight.SEMI_BOLD};
  line-height: ${LineHeight.SMALL};
  margin: 12px 0 0;
  min-width: 72px;
  white-space: nowrap;
`;
